import { render } from "./SignupTemplate.vue?vue&type=template&id=950a0ab6"
import script from "./SignupTemplate.vue?vue&type=script&lang=js"
export * from "./SignupTemplate.vue?vue&type=script&lang=js"
script.render = render

export default script